import { DeviceConfig, DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";
import { convertConfigHvac } from "../common-hvac";

export default class PoolDeviceSolarHeater extends PoolDevice implements PoolDeviceInterface {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.SOLARHEATER;
    static Icon = "solar-heater";
    static PickerTitle = Locale.gettext("Solar Heater");

    getConfig(AutoFilterVersion?: number): DeviceConfig {
        return convertConfigHvac(this.deviceConfig, AutoFilterVersion);
    }
}
